import classNames from 'classnames';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import './style.scss';

const InfoBox = ({ infoStatus }) => {
  const [visible, setVisible] = useState(true);

  const { t } = useTranslation();

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
    }, 3000);

    return () => {
      clearTimeout(timer);
    };
  }, []);

  let message = '';
  switch (infoStatus) {
    case 'success':
      message = t('New schedule added successfully');
      break;
    case 'delete':
      message = t('Schedule deleted');
      break;
    case 'error':
      message = t('The schedule for this time already exists');
      break;
    case 'edit':
      message = t('schedule changed successfully');
      break;
  }

  return (
    <>
      {visible && (
        <div
          className={classNames('banner-container', {
            success: infoStatus === 'success' || infoStatus === 'edit',
            info: infoStatus === 'delete',
            error: infoStatus === 'error',
          })}
        >
          <span className="title">{message}</span>
        </div>
      )}
    </>
  );
};

export default InfoBox;
